import type { RegistrationStatus } from '@/entities/user';
import { apiClient } from '@/shared/api';
import type { ApiResponse } from '@/shared/api/types';

export const registrationApi = {
  /** Sends the Firebase phone sign-in ID token; the API stores the verified phone. */
  verifyPhone: async (idToken: string, phoneNumber: string): Promise<{ phoneNumber: string }> => {
    const response = await apiClient.post<ApiResponse<{ phoneNumber: string; countryId: number }>>(
      '/v1/user/phone/verify',
      { idToken, phoneNumber },
    );
    return response.data.data;
  },

  getStatus: async (): Promise<RegistrationStatus> => {
    const response = await apiClient.get<ApiResponse<RegistrationStatus>>('/v1/user/registration');
    return response.data.data;
  },

  /** Activates the account (API refuses without verified phone + photo). */
  complete: async (): Promise<{ nodeTypeId: number }> => {
    const response = await apiClient.post<ApiResponse<{ nodeTypeId: number }>>(
      '/v1/user/registration/complete',
    );
    return response.data.data;
  },
};
